import { IsIn, IsOptional, IsUUID } from 'class-validator';
import {
  INGREDIENT_ORGANIC_STATUSES,
  type IngredientOrganicStatus,
} from './ingredient-organic-status.enum';

/**
 * Declares (or replaces) the organic status of one ingredient, for the
 * tenant making the call (art. 30 Reg. (UE) 2018/848). `organicStatus` is
 * required: "not declared" is reached only by clearing the declaration
 * (`DELETE .../organic`), never by sending an empty status here — a required
 * field prevents an accidental PUT from silently reverting a real
 * declaration back to "unknown".
 *
 * `organicProofDocumentId` must belong to the calling tenant's own document
 * archive (checked server-side, same rule as the nutrition source document).
 */
export class IngredientOrganicDeclarationInputDto {
  @IsIn(INGREDIENT_ORGANIC_STATUSES)
  organicStatus!: IngredientOrganicStatus;

  @IsOptional()
  @IsUUID()
  organicProofDocumentId?: string | null;
}
